import { ReactComponent as CheckSvg } from '@common/assets/icons/check.svg';
import { ReactComponent as CloseSvg } from '@common/assets/icons/close.svg';
import { Icon } from '@common/general-ui/icon/icon.component';
import React from 'react';

export enum EIcon {
    check = 'check',
    close = 'close',
}

const ICONS_MAP: Record<EIcon, React.FC> = {
    [EIcon.check]: CheckSvg,
    [EIcon.close]: CloseSvg,
};
interface IProps {
    icon: EIcon;
    className?: string;
}

export const SvgIcon = ({ icon, className }: IProps): JSX.Element => {
    const Svg = ICONS_MAP[icon];
    return <Icon icon={Svg} className={className} />;
};
